export const name = 'switch-currency';

export const SwitchCurrency = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    stroke="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.59204 6.57788L5.36641 2.78101L9.14641 6.55538"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M5.36639 2.78101L5.36639 16.4666"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M12.6113 16.0841L12.6113 2.53345"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="bevel"
    />
    <path
      d="M16.4084 12.3096L12.6115 16.0839L8.83716 12.3096"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);
